
import moment from 'moment';
import { checkCDNUrl } from '@/utils/utils';


/**
 *
 * This Auth serializer is responsible for converting the Raw format to model.
 *
 */
export class ContentSerializer {

         static get instance() {
           return this.INSTANCE;
         }
         private static INSTANCE = new ContentSerializer();


         public uploadModelItemsSerializer(res: any) {
           const result = {
             contentIngestItems: res.contentIngestItems.map((data: any) => {
              const item: any = JSON.parse(data.row_data);
              return {
                 uniqueId: item.UniqueId,
                 validationFailedReason: data.validation_failed_reason,
               };
             }),
             count: res.count,
           };
           return result;
         }

         public uploadModelSerializer(res: any, type: any) {
          const  responseData = type === 'course' ? res.courseIngestRequests : type === 'resource' ?
            res.contentIngestRequests : type === 'question' ?  res.contentIngestRequests : [];
          const result = {
             content: responseData.map(
               (data: any) => {
                 return {
                   name: data && data.file_display_name ? data.file_display_name : data.file_name,
                   id: data.id,
                   status: data.status,
                   uploadDate: moment
                     .utc(data.uploaded_at)
                     .local()
                     .format('DD/MM/YYYY HH:mm A'),
                   resourceCount: data.records_count > 0 ? data.records_count : '-' ,
                   processCount: data.records_count - data.validation_failed_count,
                   errorCount: data.validation_failed_count,
                   jobId: data && data.job && data.job.id ?  data.job.id : '',
                   tenantId: data.tenant,
                 };
               },
             ),
             count: res.count,
           };
          return result;
         }
         public serializeContentProviderList(payload: any) {
          const publishers = payload.contentRegistry ? payload.contentRegistry : [];
          const publishersList: any = [];
          publishers.forEach((publisher: any) => {
            const toolData = publisher.toolDetails || null;
            const publisherInfo: any = this.normalizePublisherInfo(publisher);
            publisherInfo.toolData = toolData ? this.serializeToolData(toolData) : null;
            publishersList.push(publisherInfo);
          });
          const payloadObject = {
            contentRegistry: publishersList,
            totalCount: payload.totalCount,
          };
          return payloadObject;
        }
        public serializeToolData(toolPayload: any) {
          const toolConfig = toolPayload.toolConfig;
          const metadata = toolPayload.metadata;
          const toolData: any = {
            id: toolPayload.id || toolPayload.toolId,
            name: toolPayload.name || toolPayload.toolName,
            description: toolPayload.description || toolPayload.toolDescription,
            clientId: toolPayload.clientId,
            subscribeStatus: toolPayload.subscribeStatus,
            code: toolPayload.code,
            registryType: toolPayload.registryType,
            tenantId: toolPayload.tenantId,
            toolCategory: toolPayload.toolCategory,
            toolType: toolPayload.toolType,
            toolDataIn: toolPayload.toolDataIn,
            toolVisibility: toolPayload.toolVisibility,
            providerId: toolPayload.learningToolProviderId,
            publisherId: toolPayload.publisherId,
            audience: toolPayload.audience || null,
            thumbnail: checkCDNUrl(toolPayload.thumbnail),
            subject: toolPayload.subject || null,
            category: toolPayload.category || null,
            grades: toolPayload.grades && toolPayload.grades.length ? toolPayload.grades : [],
            rating: metadata.rating,
            toolMetrics: toolPayload.metrics || {},
            customParams: metadata.customParams || null,
            subjectData: toolPayload.subjectData || null,
            gradeData: toolPayload.gradeData || [],
            categoryData: toolPayload.categoryData || {},
          };
          if (toolData.redirectURI) {
            toolData.redirectURI = toolData.redirectURI.toString();
          }
          return toolData;
        }
        private normalizePublisherInfo(payload: any) {
          const info = payload.info || null;
          const grades = payload.grades || [];
          if (grades instanceof Array) {
            grades.map((grade: any) => {
              grade.grade = grade.title;
            });
          }
          const publisherData = {
            id: payload.id || payload.productId,
            name: payload.name || payload.productName,
            description: payload.description || payload.productDescription,
            partner: payload.partnerId,
            contentType: payload.groupCode || 'premium',
            contentURL: payload.website || payload.iconUrl,
            subject: payload.subject ? payload.subject.id : null,
            category: payload.category || null,
            grades,
            audience: payload.audience || 'student',
            thumbnail: checkCDNUrl(payload.thumbnail),
            partnerId: payload.partnerId,
            partnerLogo: payload.partnerLogo,
            partnerName: payload.partnerName,
            partnerWebsite: payload.partnerWebsite,
            status: payload.status,
            subjectData: payload.subject,
            isPartnerLogoFaild: false,
          };
          return publisherData;
        }
        }

export const contentSerializer = ContentSerializer.instance;
